import {
  predicateQueryKeyByParams,
  useOptimisticUpdateMutation,
} from "../../../hooks/useOptimisticUpdateMutation";
import GroupsService from "../../../services/GroupsService";
import {
  COACH_GROUPS_COUNT_QUERY_KEY,
  COACH_GROUPS_LIST_QUERY_KEY,
} from "../../../routes/coach/groups/CoachGroupsListRoute";
import {
  IGroupsCountDto,
  GroupStatus,
  PaginatedListOfGroupDto,
} from "@growth-machine-llc/stridist-api-client";
import { useQueryClient } from "@tanstack/react-query";
import { NAVBAR_GROUP_LIST_QUERY_KEY } from "../GroupNavItemList";
import { getGroupsCountFromAction } from "../../../contexts/CoachTabsContext";

interface UpdateGroupArchivedMutationProps {
  disableToastAlerts?: boolean;
}

export const useUpdateGroupArchivedMutation = (
  options: UpdateGroupArchivedMutationProps = {},
) => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    queryKey: [COACH_GROUPS_LIST_QUERY_KEY],
    mutationFn: GroupsService.archiveGroup,
    optimisticUpdater: {
      updateFn: (oldData: PaginatedListOfGroupDto, variables) => {
        const newData = PaginatedListOfGroupDto.fromJS(oldData);
        newData.items = newData?.items?.filter(
          (group) => group.id !== variables.id,
        );
        newData.totalCount = oldData?.totalCount - 1;
        return newData;
      },
      predicateFn: (queryKey: any, variables) =>
        predicateQueryKeyByParams(queryKey, {
          status: variables.archived
            ? GroupStatus.ACTIVE
            : GroupStatus.ARCHIVED,
        }),
    },
    ...options,
    options: {
      onSuccess: (_, { archived }) => {
        queryClient.setQueryData<IGroupsCountDto>(
          [COACH_GROUPS_COUNT_QUERY_KEY],
          (prev) =>
            prev
              ? getGroupsCountFromAction(
                  prev,
                  archived ? "archive" : "unarchive",
                )
              : prev,
        );

        queryClient.invalidateQueries({
          queryKey: [NAVBAR_GROUP_LIST_QUERY_KEY],
        });

        queryClient.resetQueries({
          queryKey: [
            COACH_GROUPS_LIST_QUERY_KEY,
            {
              status: archived ? GroupStatus.ARCHIVED : GroupStatus.ACTIVE,
            },
          ],
          type: "all",
        });
      },
    },
  });
};
